// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9VpGD","toggleWrap":"styles_toggleWrap__1HICK","content":"styles_content__1Xqai","selectAreaCode":"styles_selectAreaCode__2PD2A"};